import React from 'react';
import PropTypes from 'prop-types';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import Switch from 'react-ios-switch';

const PublicProfile = ({ loading, label, isPrivate, onChange }) => (
  <>
  {!loading && (
    <PanelClaro sectionName="public-profile">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h3 className="micuenta-title">
                <strong>{label.title}</strong>
              </h3>
            </div>
          </div>
        </div>
        <div id="publicProfile">
          <div className="col-lg-7 col-md-7 col-sm-8 col-xs-12 padding-top-05">
            <p>{isPrivate ? label.subTitleOn : label.subTitleOff}</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-2 col-xs-8 padding-top-1 pull-right">
            <Switch
              checked={isPrivate}
              disabled={false}
              handleColor="white"
              maxOffset={20}
              offColor="white"
              onColor="rgb(67,155,187)"
              pendingOffColor="#e5e5e5;"
              onChange={onChange}
            />
          </div>
        </div>
      </div>
      </PanelClaro>
    )}
  </>
);

PublicProfile.propTypes = {
  label: PropTypes.object,
  loading: PropTypes.bool,
  isPrivate: PropTypes.bool,
  onChange: PropTypes.func,
};
export default PublicProfile;
